import React, { useState } from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Countries from "./../../../data/countries";
import ClassAttendance from "./class-attendance";
import EventAttendance from "./event-attendance";
import TripAttendance from "./trip-attendance";
let Attendance = () => {
  let [activeTab, setActiveTab] = useState("Class Attendance");
  const Tags = [
    {
      title: "Class Attendance",
    },
    {
      title: "Event Attendance",
    },
    {
      title: "Trip Attendance",
    },
  ];
  let State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];
  return (
    <SideMenu>
      <div className="page-container">
        <div className="attendance-tags-container">
          {Tags.map((tagsValue, tagsIndex) => {
            return (
              <Button
                className={
                  activeTab === tagsValue.title
                    ? "attendance-selected-tag"
                    : "attendance-un-selected-tags"
                }
                variant="text"
                key={tagsIndex}
                onClick={() => setActiveTab(tagsValue.title)}
              >
                {tagsValue.title}
              </Button>
            );
          })}
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={7} xs={12}>
              <div>
                <p className="header-input-heading">Search by class name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by class name"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={5} xs={12}>
              <div>
                <p className="header-input-heading">Search by Tutor</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by tutor"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Country</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {Countries.map((countriesValue, countriesIndex) => {
                    return (
                      <option key={countriesIndex} value={countriesValue.name}>
                        {countriesValue.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">State</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            {activeTab !== "Class Attendance" && (
              <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
                <div>
                  <p className="header-input-heading">city</p>
                  <select className="header-dropdown">
                    <option value="">Select</option>
                    {State.map((stateValue, stateIndex) => {
                      return (
                        <option key={stateIndex} value={stateValue.title}>
                          {stateValue.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
            )}
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Status</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  <option value="Complated">Complated</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={4} sm={4} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
            <Grid item xl={7} lg={7} md={6} sm={6} xs={12}></Grid>
          </Grid>
        </Box>
        <br />
        {activeTab === "Class Attendance" && <ClassAttendance />}
        {activeTab === "Event Attendance" && <EventAttendance />}
        {activeTab === "Trip Attendance" && <TripAttendance />}
      </div>
    </SideMenu>
  );
};
export default Attendance;
